import { render } from "./LeavePeriod.vue?vue&type=template&id=0a3d74b4&scoped=true"
import script from "./LeavePeriod.vue?vue&type=script&lang=js"
export * from "./LeavePeriod.vue?vue&type=script&lang=js"

import "./LeavePeriod.vue?vue&type=style&index=0&id=0a3d74b4&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3d74b4"]])

export default __exports__